export const API_SIGNER = 'dcl:marketplace'
